package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.em
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp

@Composable
fun JobHeader(createdAt: String) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .requiredHeight(42.toScaleDp())
            .background(color = Color.White)
            .drawBehind {
                val strokeWidth = Dp(1f).toPx()
                drawLine(
                    color = BorderColor,
                    start = Offset(0f, size.height - strokeWidth / 2),
                    end = Offset(size.width, size.height - strokeWidth / 2),
                    strokeWidth = strokeWidth
                )
            }
            .padding(horizontal = 23.toScaleDp(), vertical = 10.toScaleDp())
    ) {
        Text(
            text = createdAt,
            color = Color(0xff323232),
            lineHeight = 1.71.em,
            style = TextStyle(
                fontSize = 14.toScaleSp(), fontWeight = FontWeight.Bold
            ),
            modifier = Modifier
                .align(alignment = Alignment.TopStart)
                .wrapContentHeight(align = Alignment.Bottom)
                .fillMaxWidth(),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
    Spacer(modifier = Modifier.height(8.toScaleDp()))
}
